import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { isEmpty } from 'lodash';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { FilterButtons } from 'aurora-components';
import { getFilterData, isEmptyObject, SIDEBAR_FILTERS_LENGTH } from '../constants';
import Filter from '../Filter';

import styles from './styles';

const ADGMFiltersSideBar = ({
  classes,
  formData,
  filters,
  appliedFilters,
  propertyFilterOptions,
  selectedPropertyFilter,
  leaseTypeFilterOptions,
  selectedLeaseTypeFilter,
  leaseTypeFilterHandler,
  dropDowns,
  handleChange,
  handlePrefixChange,
  filtersResetHandler,
  propertyFiltersHandler,
  showFiltersModalHandler,
  searchHandler,
  showClearAll,
  filterTitle,
  filterBtnTitle,
  isPMABank,
  REQUIRED_SIDEBAR_FILTERS_LENGTH,
}) => {
  const checkRequired = filtersArr => {
    let status = false;
    filtersArr?.slice(0, REQUIRED_SIDEBAR_FILTERS_LENGTH || SIDEBAR_FILTERS_LENGTH)?.forEach(filterItem => {
      const { ...filterData } = getFilterData(filterItem, formData, dropDowns);
      if (filterData?.required && !filterData?.value) {
        status = true;
      }
    });
    return status;
  };
  const renderFilter = filterName => {
    const { renderCondition = true, type, ...filterData } = getFilterData(filterName, formData, dropDowns);
    return renderCondition ? (
      <div className={classes.filter}>
        <Filter
          name={filterName}
          type={type}
          data={filterData}
          handleChange={handleChange}
          showDropdownAsPrefix={filterName === 'certificateNo'}
          dropDownOptions={filterData}
          onPrefixChange={handlePrefixChange}
          dropDownValue={formData?.prefix}
        />
      </div>
    ) : null;
  };

  const disabledBtn = useMemo(
    () =>
      isPMABank
        ? (!formData?.plotNumber &&
            !formData?.unitNumber &&
            !formData?.buildingRegNumber &&
            !formData?.unitRegNo &&
            !formData?.premiseId) === true &&
          (!formData?.municipality || !formData?.district || !formData?.community) === true
        : isEmpty(appliedFilters) && isEmptyObject(formData),
    [formData, isPMABank],
  );

  let disableSearch = false;
  disableSearch = checkRequired(filters);
  return (
    <div className={classes.container}>
      <div className={classes.titleContainer}>
        <Typography variant='h5' className={classes.title}>
          {keyEmptyCheck(filterTitle)}
        </Typography>
        {showClearAll && (
          <Button variant='contained' className={classes.resetBtn} onClick={filtersResetHandler} disabled={disabledBtn}>
            {keyEmptyCheck('reset_filters')}
          </Button>
        )}
      </div>
      {!isEmpty(propertyFilterOptions) && (
        <FilterButtons
          selected={selectedPropertyFilter}
          options={propertyFilterOptions}
          onSwitchHandler={propertyFiltersHandler}
        />
      )}
      {!isEmpty(leaseTypeFilterOptions) && (
        <FilterButtons
          selected={selectedLeaseTypeFilter}
          options={leaseTypeFilterOptions}
          onSwitchHandler={leaseTypeFilterHandler}
        />
      )}

      <div className={classes.filtersList}>
        {filters?.slice(0, isPMABank ? 5 : SIDEBAR_FILTERS_LENGTH)?.map(filter => renderFilter(filter))}
      </div>
      <span className={classes.hr} />
      <div className={classes.actionButtonsContainer}>
        {filters?.length > (isPMABank ? 5 : SIDEBAR_FILTERS_LENGTH) && (
          <Button variant='contained' className={classes.showFiltersBtn} onClick={showFiltersModalHandler}>
            <span className={classes.showFiltersBtnIcon}>
              <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                <g clipPath='url(#clip0_1347_2701)'>
                  <path
                    d='M2.25 14C2.25 14.4125 2.5875 14.75 3 14.75H6.75V13.25H3C2.5875 13.25 2.25 13.5875 2.25 14ZM2.25 5C2.25 5.4125 2.5875 5.75 3 5.75H9.75V4.25H3C2.5875 4.25 2.25 4.5875 2.25 5ZM9.75 15.5V14.75H15C15.4125 14.75 15.75 14.4125 15.75 14C15.75 13.5875 15.4125 13.25 15 13.25H9.75V12.5C9.75 12.0875 9.4125 11.75 9 11.75C8.5875 11.75 8.25 12.0875 8.25 12.5V15.5C8.25 15.9125 8.5875 16.25 9 16.25C9.4125 16.25 9.75 15.9125 9.75 15.5ZM5.25 8V8.75H3C2.5875 8.75 2.25 9.0875 2.25 9.5C2.25 9.9125 2.5875 10.25 3 10.25H5.25V11C5.25 11.4125 5.5875 11.75 6 11.75C6.4125 11.75 6.75 11.4125 6.75 11V8C6.75 7.5875 6.4125 7.25 6 7.25C5.5875 7.25 5.25 7.5875 5.25 8ZM15.75 9.5C15.75 9.0875 15.4125 8.75 15 8.75H8.25V10.25H15C15.4125 10.25 15.75 9.9125 15.75 9.5ZM12 7.25C12.4125 7.25 12.75 6.9125 12.75 6.5V5.75H15C15.4125 5.75 15.75 5.4125 15.75 5C15.75 4.5875 15.4125 4.25 15 4.25H12.75V3.5C12.75 3.0875 12.4125 2.75 12 2.75C11.5875 2.75 11.25 3.0875 11.25 3.5V6.5C11.25 6.9125 11.5875 7.25 12 7.25Z'
                    fill='#999999'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_1347_2701'>
                    <rect width='18' height='18' fill='white' transform='translate(0 0.5)' />
                  </clipPath>
                </defs>
              </svg>
            </span>
            {keyEmptyCheck('advanced_filters')}
          </Button>
        )}
        <Button
          variant='contained'
          className={classes.searchBtn}
          onClick={searchHandler}
          disabled={disabledBtn || disableSearch}
        >
          {keyEmptyCheck(filterBtnTitle)}
        </Button>
      </div>
    </div>
  );
};

ADGMFiltersSideBar.propTypes = {
  classes: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  appliedFilters: PropTypes.object.isRequired,
  propertyFilterOptions: PropTypes.array.isRequired,
  selectedPropertyFilter: PropTypes.string.isRequired,
  leaseTypeFilterOptions: PropTypes.array.isRequired,
  selectedLeaseTypeFilter: PropTypes.string.isRequired,
  leaseTypeFilterHandler: PropTypes.func.isRequired,
  dropDowns: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  filtersResetHandler: PropTypes.func.isRequired,
  propertyFiltersHandler: PropTypes.func.isRequired,
  showFiltersModalHandler: PropTypes.func.isRequired,
  searchHandler: PropTypes.func.isRequired,
  handlePrefixChange: PropTypes.func,
  showClearAll: PropTypes.bool,
  filterTitle: PropTypes.string,
  filterBtnTitle: PropTypes.string,
  isPMABank: PropTypes.bool,
  REQUIRED_SIDEBAR_FILTERS_LENGTH: PropTypes.number.isRequired,
};
ADGMFiltersSideBar.defaultProps = {
  handlePrefixChange: () => {},
  filterTitle: 'Filters',
  showClearAll: true,
  filterBtnTitle: 'search',
  isPMABank: false,
};
export default withStyles(styles)(ADGMFiltersSideBar);
